module.exports = __webpack_public_path__ + "media/10.1c8515d2.mp3";